export default {
  instructions: `
    Reproduzca el vídeo para aprender a grabar su voz en el siguiente paso.
  `,
  done: `
    Pulse el botón <b>Continuar</b> cuando haya terminado.
  `,
};
